import { Breadcrumbs as PounceBreadcrumbs } from 'pounceV2';
import React from 'react';
import { useBreadcrumbContext } from 'Source/contexts/breadcrumbContext';

interface BreadcrumbProps {
  truncated?: boolean;
}

const BreadcrumbsV3: React.FC<BreadcrumbProps> = ({ truncated = false }) => {
  const { crumbs } = useBreadcrumbContext();

  return <PounceBreadcrumbs items={crumbs} truncated={truncated} />;
};

export default BreadcrumbsV3;
